export default {"src":"__ASTRO_ASSET_IMAGE__tQaVMTiC__","width":1741,"height":1686,"format":"jpg"}